<template>
    <el-dialog class="el-dialogs" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-row :gutter="4" class="h100 borderwa">
            <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']"
                    v-loading="showList && treeLoading">
                <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                     @click="showList = !showList"></div>
                <el-tree class="h100 p_all1 treeDisplay" :data="treeData" :props="defaultProps"
                         :expand-on-click-node="false"
                         ref="myTree" node-key="id" highlight-current default-expand-all @node-click="selTreeNode">
                </el-tree>
            </el-col>
            <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
                <div class="el-table-container">
                    <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                             @keyup.enter.native="refreshList(1,1)">
                        <el-form-item prop="keyword" label="关键字：">
                            <el-input v-model.trim="searchForm.keyword" maxlength="20"
                                      placeholder="请输入关键字(限20字)"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="refreshList(1,1)" size="small"
                                       icon="el-icon-search">
                                查询
                            </el-button>
                            <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="text_right p_all1">
                        <el-button type="primary" size="small" @click="addData('add')">新增</el-button>
                        <el-button type="primary" size="small" @click="addBatchData()">批量新增</el-button>
                        <el-button type="primary" size="small" @click="batchEnable(1)">批量启用</el-button>
                        <el-button type="primary" size="small" @click="batchEnable(0)">批量禁用</el-button>
                        <el-button type="primary" size="small" @click="exportData()">导出</el-button>
                        <el-button type="danger" size="small" @click="deleteData()">删除</el-button>
                    </div>
                    <el-table
                            :data="dataList"
                            v-loading="loading"
                            @selection-change="selectionChangeHandle"
                            size="small" height="100%"
                            class="table" ref="multipleTable" row-key='id' border>
                        <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
                        <el-table-column prop="knowledgeName" label="节点名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="knowledgeSource" label="来源" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="parentName" label="父节点" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="metadataName" label="关联元数据" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="graphNodeState" label="状态" show-overflow-tooltip>
                            <template slot-scope="{row}">
                                <el-switch
                                        v-model="row.graphNodeState"
                                        active-value="1"
                                        @change="setType(row)"
                                        inactive-value="0">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small"
                                           @click="addData('edit',scope.row)">编辑
                                </el-button>
                                <el-button type="text" size="small"
                                           @click="deleteData(scope.row)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                                @pagination="refreshList"/>
                </div>
            </el-col>
        </el-row>
        <add-min-node ref="addMinNode" @refresh="searchTree()"></add-min-node>
        <add-batch-data ref="addBatchData" @refresh="searchTree()"></add-batch-data>
    </el-dialog>
</template>

<script>
import AddMinNode from "@/views/modules/academic/point/nodeManage/addMinNode.vue";
import AddBatchData from "@/views/modules/academic/point/nodeManage/addBatchData.vue";

export default {
    name: "nodeManageList",
    components: {AddBatchData, AddMinNode},
    data() {
        return {
            title: '节点管理',
            visible: false,
            showList: true,
            treeData: [],
            treeLoading: false,
            defaultProps: {
                children: 'children',
                label: 'knowledgeName'
            },
            searchForm: {
                nodeId: '',
                keyword: '',
                current: 1,
                size: 20,
            },
            total: 0,

            dataList: [],
            dataListSelect: [],
            loading: false,
            setlectData: {},
        }
    },

    methods: {
        init(row) {
            this.visible = true
            this.showList = true
            this.setlectData = row
            this.searchTree(row)
        },

        // 查询树状数据
        searchTree() {
            this.treeLoading = true
            this.$axios(this.api.academic.knowledgegraphnodeGetById + this.setlectData.id).then(res => {
                if (res.status) {
                    this.treeData = [
                        {
                            id: '',
                            knowledgeName: this.setlectData.knowledgeName,
                            children: [],
                        }
                    ]
                    this.treeData[0].children = res.data
                    this.$nextTick(() => {
                        this.$refs.myTree.setCurrentKey(this.treeData[0].id);
                        this.selTreeNode(this.treeData[0])
                    });
                }
                this.treeLoading = false
            })
        },

        // 选择树节点
        selTreeNode(val) {
            this.searchForm.id = val.id
            this.refreshList(1,1)
        },

        // 获取数据列表
        refreshList(type,ressfas) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (ressfas){
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.newSearchData = {
                ...this.searchForm,
                knowledgeId: this.setlectData.id,
            }
            this.$axios(this.api.academic.knowledgegraphnodeList, this.newSearchData, 'get').then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length === 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.dataList.map(item => {
                        delete item.children
                    })
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败');
                }
            })
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },
        // 重置
        reset() {
            this.dataListSelect = []
            this.$refs.searchForm.resetFields();
            this.refreshList(1,1)
        },

        //type add新增 edit编辑
        addData(type, row) {
            this.$refs.addMinNode.init(type, row, this.setlectData,this.searchForm.id)
        },

        //批量新增
        addBatchData() {
            this.$refs.addBatchData.init(this.setlectData)
        },

        //批量启用 1启用 0禁用
        batchEnable(num) {
            if (this.dataListSelect.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = this.dataListSelect.map(item => {
                return item.id
            })
            this.$axios(this.api.academic.knowledgegraphnodeBatchUpdate, {
                ids,
                graphNodeState:num,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success(`${num == 1 ? '启用' : '禁用'}成功`)
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //导出
        exportData() {
            if (this.total == 0) {
                this.$message.warning('暂无可导出的数据!')
                return
            }
            let ids = this.dataListSelect.map(item => {
                return item.id
            })
            this.exportExcel(this.api.academic.knowledgegraphnodeExport, {
                ids,
                ...this.newSearchData
            }, '节点管理', 'post')
        },

        //删除
        deleteData(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.graphNodeState == '1'){
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`确认删除所选信息？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.knowledgegraphnodeRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                        this.searchTree();
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //切换显示状态
        setType(row) {
            row.graphNodeState = row.graphNodeState == '1' ? '0' : '1'
            if (row.graphNodeState == '1'){
                this.$confirm(`禁用后，节点及节点之下的所有子节点都将同步禁用！`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.academic.knowledgegraphnodeUpdateById, {
                        id: row.id,
                        graphNodeState: row.graphNodeState == 1 ? 0 : 1,
                    }, 'put').then(data => {
                        if (data && data.status) {
                            this.$message.success('状态修改成功')
                            this.refreshList('', 1)
                        } else {
                            this.$message.error(data.msg)
                            this.refreshList('', 1)
                        }
                    })
                })
            }else {
                this.$axios(this.api.academic.knowledgegraphnodeUpdateById, {
                    id: row.id,
                    graphNodeState: row.graphNodeState == 1 ? 0 : 1,
                }, 'put').then(data => {
                    if (data && data.status) {
                        this.$message.success('状态修改成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                        this.refreshList('', 1)
                    }
                })
            }
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    // if (this.searchForm.id) {
                    //     this.$axios(this.api.academic.webresourceUpdateById, this.searchForm, 'put').then(data => {
                    //         if (data && data.status) {
                    //             this.$message.success('修改成功')
                    //             this.visible = false
                    //             this.$emit('refresh')
                    //         } else {
                    //             this.$message.error(data.msg)
                    //         }
                    //     })
                    // } else {
                    //     this.$axios(this.api.academic.webresourceSave, this.searchForm, 'post').then(data => {
                    //         if (data && data.status) {
                    //             this.$message.success('保存成功')
                    //             this.visible = false
                    //             this.$emit('refresh')
                    //         } else {
                    //             this.$message.error(data.msg)
                    //         }
                    //     })
                    // }
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.borderwa {
  border: 4px solid #f7f7f7;
}

.h100i {
  border-right: 4px solid #f7f7f7;
}

.treeDisplay {
  overflow-y: auto;

  .el-tree-node__expand-icon {
    display: none !important;
  }

  .treeIcon {
    width: 14px;
    vertical-align: sub;
    margin-right: 5px;
  }

  .label {
    font-size: 12px;
  }
}

.treeDisplay::-webkit-scrollbar {
  display: none;
}

.treeDisplay::-webkit-scrollbar {
  display: none;
}
</style>
